.sourcesDivider {
  margin-top: 8px;
}

.chordView {
  font-size: 32px;
}

.bussesDivider {
  margin-top: 16px;
}

.sampleRate {
  display: block;
  margin-top: 16px;
}
